export const formActionTypes = {
    START_FORM_EDITING: "START_FORM_EDITING",
    CANCEL_FORM_EDITING: "CANCEL_FORM_EDITING",
    CHANGE_FIELD_VALUE: "CHANGE_FIELD_VALUE",
    UPDATE_FORM_VALIDITY: "UPDATE_FORM_VALIDITY",
    UPDATE_FORM_VALIDATION_RULES: "UPDATE_FORM_VALIDATION_RULES",
}